export default __webpack_public_path__ + "static/media/color codes.5dc01dc1.txt";